import useHcAnalytics from "../composables/useHcAnalytics";

const { openAnalyticsChat } = useHcAnalytics();

function initAnalyticsChat() {
    const startChatElement = document.getElementById("hcStartChat");
    const startChatHeaderElement = document.getElementById("hcStartChatHeader");

    if (!startChatElement || !startChatHeaderElement) return;

    startChatElement.addEventListener("click", openAnalyticsChat);
    startChatHeaderElement.addEventListener("click", openAnalyticsChat);
}

document.ready(() => {
    initAnalyticsChat();
});
